import { render, staticRenderFns } from "./ProjetoAnexos.vue?vue&type=template&id=6f0efb5e"
import script from "./ProjetoAnexos.vue?vue&type=script&lang=js"
export * from "./ProjetoAnexos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports